import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import OrderBatchDownloadPDF from './OrderBatchDownloadPDF';
import { IoIosSend } from 'react-icons/io';
import { Button } from '../../common/Form';
import BookletOrderItem from './BookletOrderItem';
import { sendOrderBatchPdfLink } from '../../queries/booklet';

import * as XLSX from 'xlsx';

const { REACT_APP_BASE_URL } = process.env;

const BookletDownloadPDFModal = ({ bookletId, selectedBatch }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [sendOrderBatchPdfLinkMutation, { loading }] = useMutation(sendOrderBatchPdfLink);

  const sendEmail = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    // Prevent multiple clicks
    if (loading) return;

    // Reset message
    setMessage(null);

    try {
      await sendOrderBatchPdfLinkMutation({
        variables: {
          email,
          bookletId,
          batchLabel: selectedBatch.batchLabel,
          portalUrlForEmails: `${REACT_APP_BASE_URL}/`
        },
      });
      setMessage('Ett mail med länk till PDF har skickats till ' + email);
    } catch (error) {
      console.error('Error sending email:', error);
      setMessage('Ett fel inträffade vid skickandet av e-post.');
    } finally {
      setEmail('');
    }
  };

  const handleDownloadExcel = (e) => {
    e.preventDefault();

    const codes = selectedBatch.orders.map(order => order.code);

    const fileName = (
      selectedBatch?.batchLabel
        ? selectedBatch.batchLabel
        : 'Ordrar via webbshop'
    ).replace(/ /g, '-');

    const worksheet = XLSX.utils.aoa_to_sheet(
      codes.map(code => [String(code)])
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Koder');

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <div>
      {/* PDF options */}
      <div className="modal-top mb-lg">
        <h4 className='block mb-lg max-w'>
          {selectedBatch?.batchLabel
            ? selectedBatch.batchLabel
            : 'Ordrar via webbshop'
          }
        </h4>
        <OrderBatchDownloadPDF
          bookletId={bookletId}
          batchLabel={selectedBatch.batchLabel}
        />
        <b className='block'>Skicka mail med länk till PDF</b>
        <div
          role="form"
          className="flex flex-col max-w relative p-0 mb"
        >
          <label htmlFor="email">E-postadress</label>
          <input
            type="email"
            style={{ paddingRight: 40 }}
            id="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                sendEmail(e);
              }
            }}
          />
          <Button
            type="button"
            className="primary send-email-btn"
            loading={loading}
            onClick={sendEmail}
          >
            <IoIosSend size={20} />
          </Button>
        </div>
        {message && (
          <small className="message flex flex-col max-w">
            {message}
          </small>
        )}
      </div>

      {/* List of codes */}
      <div className="order-list">
        {selectedBatch.orders.length > 0 && (<>
          <div className="order-list-top flex items-center justify-between">
            {selectedBatch?.batchLabel
              ? <b className='text-left block'>Värdebevis ({selectedBatch.orders.length})</b>
              : <b className='text-left block'>Ordrar ({selectedBatch.orders.length})</b>
            }
            <button className='btn-export btn primary xs' onClick={handleDownloadExcel}>
              Exportera koder
            </button>
          </div>
          <ul>
            {selectedBatch.orders.map((order, index) => (
              <BookletOrderItem
                key={order._id}
                order={order}
                index={index}
              />
            ))}
          </ul>
        </>)}
      </div>
    </div>
  );
};

export default BookletDownloadPDFModal;
